import userAddress from "./modules/userAddress";

const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  menus: state => state.user.menus,
  orderactive: state => state.pageStore.orderActive,
  addressList: state => state.userAddress.addressList
}
export default getters
